<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.jobs')}`">
              <div class="v-table">
                <TableServer type="jobs" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.job-items')}`">
              <div class="v-table">
                <TableServer type="jobItems" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-job')}`">
              <JobForm v-if="fetcherAdminSchemas.forms['Job']" />
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-job-item')}`">
              <JobItemForm v-if="fetcherAdminSchemas.forms['JobItem']" />
            </b-tab>
            <b-tab
              v-if="jobId !== null && fetcherAdminJob.id > 0"
              :title="`${this.$i18n.t('JSON.job')}#${jobId}`"
            >
              <JobForm
                v-if="fetcherAdminSchemas.forms['Job']"
                :job="fetcherAdminJob"
                mode="edit"
              />
            </b-tab>
            <b-tab
              v-if="jobItemId !== null && fetcherAdminJobItem.id > 0"
              :title="`${this.$i18n.t('JSON.job-item')}#${jobItemId}`"
            >
              <JobItemForm
                v-if="fetcherAdminSchemas.forms['JobItem']"
                :job-item="fetcherAdminJobItem"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {
  components: {
    MadModal: () => import('@/components/MadModal'),
    JobForm: () => import('@/components/admin/fetcher/modals/forms/JobForm'),
    JobItemForm: () => import('@/components/admin/fetcher/modals/forms/JobItemForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    jobId: {
      type: Number,
      default: () => 0,
    },
    jobItemId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminJob: (state) => state.fetcherAdminJob.fetcherAdminJob,
      fetcherAdminJobItem: (state) => state.fetcherAdminJobItem.fetcherAdminJobItem,
    }),

    modalId() {
      return 'job';
    },
  },

  watch: {
    jobId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminJob();
      }
    },

    jobItemId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminJobItem();
      }
    },
  },

  methods: {
    ...mapActions([
      'getFetcherAdminJob', //
      'getFetcherAdminJobItem',
    ]),

    async loadFetcherAdminJob() {
      try {
        await this.getFetcherAdminJob({
          params: {
            jid: this.jobId,
          },
        });

        // console.log('job', this.job);

        // success
        // console.log('success loading job!');
      } catch (error) {
        // error
        // console.log('error loading job!');
      }
    },

    async loadFetcherAdminJobItem() {
      try {
        await this.getFetcherAdminJobItem({
          params: {
            jiid: this.jobItemId,
          },
        });

        // console.log('jobItem', this.jobItem);

        // success
        // console.log('success loading jobItem!');
      } catch (error) {
        // error
        // console.log('error loading jobItem!');
      }
    },

    onOpened() {
      if (this.jobId !== null) {
        this.loadFetcherAdminJob();
      }

      if (this.jobItemId !== null) {
        this.loadFetcherAdminJobItem();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
